const SERVICE_WORKER_CLEANUP_RELOAD_KEY = 'trips_service_worker_cleanup_reloaded';

export async function unregisterExistingServiceWorkers(): Promise<void> {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();

    if (!registrations.length) {
      return;
    }

    await Promise.all(
      registrations.map(registration => registration.unregister()),
    );

    if (
      navigator.serviceWorker.controller
      && !sessionStorage.getItem(SERVICE_WORKER_CLEANUP_RELOAD_KEY)
    ) {
      sessionStorage.setItem(SERVICE_WORKER_CLEANUP_RELOAD_KEY, 'true');
      window.location.reload();
    }
  } catch {
    // Keep startup resilient if the browser blocks service worker access.
  }
}

